import { LotacaoEditableTableModel, LotacaoEditableTableSelectFieldModel } from './LotacaoEditableTable'

export const sortByNomeProfissional = (
  a: { profissional: { nome: string; nomeSocial?: string | null } },
  b: { profissional: { nome: string; nomeSocial?: string | null } }
) => (a.profissional.nomeSocial || a.profissional.nome).localeCompare(b.profissional.nomeSocial || b.profissional.nome)

const mapItems = (item: LotacaoEditableTableSelectFieldModel, index: number): LotacaoEditableTableModel => ({
  _id: index,
  lotacao: item,
})

export const convertLotacoesToLotacaoEditableTableModel = (
  lotacoes?: LotacaoEditableTableSelectFieldModel[]
): LotacaoEditableTableModel[] => lotacoes?.slice().sort(sortByNomeProfissional).reverse().map(mapItems)
